import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const AppLogo = ({ size = 'medium' }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const sizes = {
    small: { logo: 32, title: 'h6', showTagline: false, taglineSize: '12px' },
    medium: { logo: 48, title: 'h4', showTagline: true, taglineSize: '14px' },
    large: { logo: 64, title: 'h3', showTagline: true, taglineSize: '14px' },
    responsive: {
      logo: isMobile ? 36 : 48,
      title: isMobile ? 'h6' : 'h4',
      showTagline: true,
      taglineSize: isMobile ? '11px' : '14px'
    }
  };

  const config = sizes[size] || sizes.medium;

  return (
    <Box
      onClick={() => navigate('/')}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? 1.5 : 2,
        cursor: 'pointer',
        '&:hover': { opacity: 0.8 }
      }}
    >
      <img
        src="/logo.svg"
        alt="X Painkiller"
        style={{ width: config.logo, height: config.logo }}
      />
      <Box>
        <Typography
          variant={config.title}
          sx={{
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #6366f1 0%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: config.showTagline ? 0.5 : 0
          }}
        >
          X Painkiller
        </Typography>
        {config.showTagline && (
          <Typography sx={{ color: '#9ca3af', fontSize: config.taglineSize || '14px' }}>
            One dose. Zero pain points.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AppLogo;
